import React, { useState, useRef, useEffect } from 'react';
import { AppModal } from './AppModal';
import { Button } from '../';
import { Checkbox } from 'antd';
import { setSessionVar, getSessionVar } from '../../lib/helpers';
import { WelcomeModalContent } from './WelcomeModalContent';
import classNames from 'classnames';

import { useWelcomeModalMutation } from '../../api';

export const WelcomeModal = ({ open, onCancel }) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [doNotShowAgain, setDoNotShowAgain] = useState(false);
    const totalPages = 9;
    const scrollableContentRef = useRef(null);
    const contentClasses = classNames('welcome-modal-content', {
        'no-scroll': currentPage === 1,
        'compact-height': currentPage === totalPages,
        'default-height': currentPage !== 1 && currentPage !== totalPages,
    });

    const [disableWelcomeModal] = useWelcomeModalMutation();

    // Reset scroll position when page changes
    useEffect(() => {
        if (scrollableContentRef.current) {
            scrollableContentRef.current.scrollTop = 0;
        }
    }, [currentPage]);

    const handlePrevious = () => {
        if (currentPage > 0) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNext = async () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        } else {
            dismissWelcomeModal();
        }
    };

    const handleClose = () => {
        dismissWelcomeModal();
    };

    const dismissWelcomeModal = async () => {
        const user = getSessionVar('user');
        user.show_intro = false;
        setSessionVar('user', user);
        setSessionVar('displayWelcomeModal', false);
        if (doNotShowAgain) {
            try {
                await disableWelcomeModal({ userId: user.id });
            } catch (error) {
                console.error('Error cancelling Welcome Modal', error);
            }
        }
        onCancel();
    };

    return (
        <AppModal
            open={open}
            onCancel={handleClose}
            maskClosable={false}
            title="Welcome to RiverMeadow"
            footer={[
                <Button key="prev" onClick={handlePrevious} disabled={currentPage === 1}>
                    Previous
                </Button>,
                <Button key="next" type="primary" onClick={handleNext}>
                    {currentPage === totalPages ? 'Finish' : 'Next'}
                </Button>,
            ]}
        >
            <div className="welcome-modal">
                <div ref={scrollableContentRef} className={contentClasses}>
                    <WelcomeModalContent page={currentPage} />
                </div>
                {currentPage === totalPages && (
                    <Checkbox
                        className="welcome-modal-checkbox"
                        checked={doNotShowAgain}
                        onChange={(e) => setDoNotShowAgain(e.target.checked)}
                    >
                        Don’t show this again
                    </Checkbox>
                )}
            </div>
        </AppModal>
    );
};
